<div class="p-3">
  <h2>Workshops rating</h2>
</div>
<div class="container-iframe">
  <iframe [src]="url" class="responsive-iframe"></iframe>
</div>
